/**
 * Les pages de score (/fr/table-checkouts/107…), réduites à ce que le navigateur
 * doit savoir de chacune : son chemin, sa langue, son groupe de traduction.
 *
 * 169 restes dans trois langues font 507 routes. Déclarées en entier dans
 * seoConfig.json — titre, description, bloc « En bref » — elles alourdissaient
 * de 150 Ko le bundle que charge chaque visiteur, pour des données qui ne
 * servent qu'à la page de score elle-même. Ici, une boucle les produit, et la
 * page calcule son titre et son texte avec le solveur qu'elle charge déjà.
 *
 * Aucun import du solveur dans ce module : il est lu par routes.js, donc par
 * le bundle principal. Les faits et les textes complets, pour le prérendu et
 * les tests, sont dans checkoutPages.js.
 */

/** La table de chaque langue : ses pages de score vivent sous elle. */
export const SCORE_BASES = {
    fr: "/fr/table-checkouts",
    en: "/en/darts-checkout-chart",
    de: "/de/dart-checkout-tabelle",
};

/** De 170, la plus haute sortie, à 2, la plus basse. lib/checkout.js en fait foi : un test le vérifie. */
export const MAX_SCORE = 170;
export const MIN_SCORE = 2;

export const SCORE_LANGS = Object.keys(SCORE_BASES);

export const scorePath = (lang, score) => `${SCORE_BASES[lang]}/${score}`;

/** Le groupe de traduction d'un reste : les trois langues d'un même score. */
export const scoreGroup = (score) => `checkout-${score}`;

/** Le dernier niveau du fil d'Ariane. */
export const SCORE_BREADCRUMB = {
    fr: (score) => `Checkout ${score}`,
    en: (score) => `${score} checkout`,
    de: (score) => `${score} Checkout`,
};

/**
 * Les routes de score, dans l'ordre des scores puis des langues, avec les
 * champs que lisent locale.js et language.js. Le français ne déclare pas sa
 * langue, comme les autres routes françaises.
 */
export function scoreRouteStubs() {
    const routes = {};
    for (let score = MAX_SCORE; score >= MIN_SCORE; score -= 1) {
        for (const lang of SCORE_LANGS) {
            routes[scorePath(lang, score)] = {
                ...(lang === "fr" ? {} : { lang }),
                group: scoreGroup(score),
                checkoutScore: score,
            };
        }
    }
    return routes;
}
